"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const inventory_service_1 = require("./inventory.service");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const permissions_1 = require("../authorization/permissions");
let InventoryController = class InventoryController {
    constructor(inventoryService) {
        this.inventoryService = inventoryService;
    }
    getStock(productId) {
        return this.inventoryService.getStock(productId ? parseInt(productId, 10) : undefined);
    }
    getLowStockAlerts() {
        return this.inventoryService.getLowStockAlerts();
    }
    upsertStock(body) {
        return this.inventoryService.upsertStock(body.productId, body.location, body.quantityOnHand, body.reorderLevel);
    }
    adjustStock(id, body) {
        return this.inventoryService.adjustStock(id, body.quantityDelta, body.reason);
    }
};
exports.InventoryController = InventoryController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.INVENTORY_READ),
    tslib_1.__param(0, (0, common_1.Query)('productId')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], InventoryController.prototype, "getStock", null);
tslib_1.__decorate([
    (0, common_1.Get)('alerts'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.INVENTORY_READ),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], InventoryController.prototype, "getLowStockAlerts", null);
tslib_1.__decorate([
    (0, common_1.Post)('upsert'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.INVENTORY_UPSERT),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], InventoryController.prototype, "upsertStock", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/adjust'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.INVENTORY_ADJUST),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], InventoryController.prototype, "adjustStock", null);
exports.InventoryController = InventoryController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('inventory'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof inventory_service_1.InventoryService !== "undefined" && inventory_service_1.InventoryService) === "function" ? _a : Object])
], InventoryController);
